import * as Yup from "yup";

const SIGNIN_VALIDATION = Yup.object({
  email: Yup.string()
    .trim()
    .email("Email must be valid")
    .required("Email address is required"),
  password: Yup.string()
    .trim()
    .min(4, "Password must be at least 6 characters")
    .required("Password is required"),
});
const FORGOT_PASS_VALIDATION = Yup.object({
  email: Yup.string()
    .trim()
    .email("Email must be valid")
    .required("Email address is required"),
});
const RESET_PASS_VALIDATION = Yup.object({
  password: Yup.string()
    .trim()
    .min(4, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .trim()
    .required()
    .label("Confirm Password")
    .oneOf([Yup.ref("password")], "Passwords does not match"),
});

export { SIGNIN_VALIDATION, FORGOT_PASS_VALIDATION, RESET_PASS_VALIDATION };
